<div class="uploadDocDia">
  <div style="text-align:right">
    <span style="font-size: 30px;cursor: pointer;" (click)="removeFile()" title="Close" mat-dialog-close>&times;</span>
  </div>

<form [formGroup]="newDocumentForm" (ngSubmit)="submitNewDocument(newDocumentForm.value)" novalidate>
       
  <div class="addDocForm"> 
      <div >
    <mat-form-field appearance="outline"> 
      <mat-label style="font-size: 17px;"> Document Name *</mat-label>
      <mat-select matInput  placeholder="Choose documentName" formControlName="documentName" (selectionChange)="populatedocType($event)" [disabled]="isdocDisable" autocomplete="off" >
         <!-- Search box inside dropdown -->
    <mat-option>
      <input
        matInput
        placeholder="Search Document Name"
        [formControl]="documentNameFilterCtrl"
        (click)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()"
      />
    </mat-option>
      <mat-option>Choose  DocumentName</mat-option>
      <mat-option *ngFor="let document of filteredDocumentNames " [value] ="document.documentName">{{document.documentName}}</mat-option>
      </mat-select>
      <mat-error *ngIf="!newDocumentForm.controls['documentName'].valid && newDocumentForm.controls['documentName'].touched">
       DocumentName is required.
      </mat-error>
    </mat-form-field>
 </div>
  <div style="display:none;">    
    <mat-form-field   appearance="outline"> 
      <mat-label style="font-size: 17px;"> Document Type *</mat-label>
      <!--<mat-select matInput  placeholder="Choose documentName" formControlName="documentType"  autocomplete="off">
       
      <mat-option>Choose  documentType</mat-option>
      <mat-option [value]="documentTypes">{{documentTypes}}</mat-option>
      </mat-select>-->
      <input type="text" matInput formControlName="documentType" placeholder="documentType" autocomplete="off" readonly>
      <mat-error *ngIf="!newDocumentForm.controls['documentType'].valid && newDocumentForm.controls['documentType'].touched">
       DocumentType is required.
      </mat-error>
    </mat-form-field>

 </div>
 <div> <mat-form-field  appearance="outline">
  <mat-label style="font-size: 17px;"> Description </mat-label>
  <input matInput placeholder="Description" formControlName="description"  autocomplete="off">
  <!--<mat-error *ngIf="newDocumentForm.controls['description'].touched && !newDocumentForm.controls['description'].dirty">
    Description is required.
  </mat-error>-->
  <mat-error *ngIf="!newDocumentForm.controls['description'].valid && newDocumentForm.controls['description'].touched && newDocumentForm.controls['description'].dirty">
    Description length should be less than or equal to 100 characters.
  </mat-error>
</mat-form-field>

</div>
<div formGroupName="uploadFileForm" style="margin:0 10px 10px 0;display: flex;">
  <!--<form [formGroup]="uploadFileForm" (ngSubmit)="uploadFile()">-->
  <input style="display:none" type="file" placeholder="Upload Document" accept="image/*,.pdf" (change)="fileChange($event, newDocumentForm)" formControlName="uploadDocument" autocomplete="off" #fileselect>
  <button style="margin-right:10px;outline: none;background-color: #ffffff;
  color: #AA004D;font-family: 'Century Gothic';" type="button"  mat-raised-button  (click)="fileselect.click()" [disabled]="!(documentNameSelected)">Select file</button>
  <span *ngIf="isFilename">{{fileName}}</span>
  <button class="uploadBtn" (click)="uploadFile()" *ngIf="!isDone && !isloading && !isEdit" mat-button type="submit" style="color:rgb(252, 252, 252);margin-left:10px"  [disabled]="!(isUploaded && documentNameSelected)" title="Upload selected file">Upload File</button>
 <!--<button class="uploadBtn" *ngIf="isloading && !isDone" mat-button type="button" style="color:rgb(252, 252, 252);margin-left:10px"  ><i class="fa fa-spinner"></i></button>-->
 <button class="uploadBtn" *ngIf="isImage || isPdf" mat-button type="button" style="color:rgb(252, 252, 252);margin-left:10px;background-color: #056090 !important;"  (click)="previewFile()" >Preview</button>

  <!--<span class="uploadBtn" *ngIf="isDone && !isloading" style="color:rgb(252, 252, 252);margin-left:10px;padding:5px;border-radius:3px;" title="uploaded " >Uploaded successfully</span>-->

<!--</form>-->
<!--<button *ngIf="isDelete" class="btn btn-danger" mat-button style="color:white;margin-left:10px" (click)="deleteDocument()" title="Remove file"><i class="fa fa-trash"></i></button>-->

</div>
<!--<div class="progress form-group" *ngIf="isBarLoading">
  <div class="progress-bar progress-bar-striped bg-success" role="progressbar" [style.width.%]="progress">{{progress + '%'}}
  </div>
  <p *ngIf="isBarLoading">Processing document, please wait...</p>
</div>-->
<div *ngIf="isBarLoading && !isDone">
<mat-progress-bar mode="determinate" class="custom-progress-bar" [value]="progress"></mat-progress-bar>
<p>Processing document, please wait...</p>
</div>

<div  formGroupName="dateGroup" *ngIf="isOpenDates">
  <span *ngIf="displayMessage" style="color: rgb(255 199 44);
font-size: 16px;">Note: Please verify the populated dates before adding the document</span>
<div> 
  <mat-form-field appearance="outline" *ngIf="isSafari">
    <mat-label style="font-size: 17px;">Start-Date/Issue-Date</mat-label>

    <input matInput
    [matDatepicker]="picker1"
    placeholder="MM/DD/YYYY"
    formControlName="uploadDate"
    readonly
    (click)="picker1.open()" (dateChange)="selectStartDate(newDocumentForm)"> 
    <button mat-icon-button
    *ngIf="newDocumentForm.get('dateGroup.uploadDate')?.value"
    matSuffix
    (click)="clearDate('uploadDate')"
    type="button">
<mat-icon>close</mat-icon>
</button>
    <mat-datepicker #picker1></mat-datepicker>
   <!--<mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>-->

    <mat-error *ngIf="newDocumentForm.get('dateGroup.uploadDate')?.invalid && newDocumentForm.get('dateGroup.uploadDate')?.touched">
      {{ errors.uploaddateValid }}
    </mat-error>
  </mat-form-field>
  <mat-form-field appearance="outline" *ngIf="!isSafari">
    <mat-label style="font-size: 17px;">Start-Date/Issue-Date</mat-label>
   
   
    <!-- Real date input -->
    <input matInput type="date" placeholder="Start Date" formControlName="uploadDate"
      (change)="selectStartDate(newDocumentForm)">
    
    <mat-error *ngIf="newDocumentForm.controls['dateGroup'].get('uploadDate').dirty && !newDocumentForm.controls['dateGroup'].get('uploadDate').valid">
      {{errors.uploaddateValid}}
    </mat-error>
  </mat-form-field>
</div>

<!-- Expiration Date -->
<div *ngIf="!noExpDate">
  <mat-form-field appearance="outline" *ngIf="isSafari">
    <mat-label style="font-size: 17px;">Expiration Date <span *ngIf="isExpDateMand">*</span></mat-label>

      <input matInput
      [matDatepicker]="picker2"
      placeholder="MM/DD/YYYY"
      formControlName="expiryDate"
      readonly
      (click)="picker2.open()" (dateChange)="selectExpDate($event)"> 
      <button mat-icon-button
      *ngIf="newDocumentForm.get('dateGroup.expiryDate')?.value"
      matSuffix
      (click)="clearDate('expiryDate')"
      type="button">
  <mat-icon>close</mat-icon>
  </button>
    <mat-datepicker #picker2></mat-datepicker>
    <!--<mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>-->

    <mat-error *ngIf="newDocumentForm.get('dateGroup.expiryDate')?.invalid && newDocumentForm.get('dateGroup.expiryDate')?.touched">
      {{ errors.expirydate }}
    </mat-error>
  </mat-form-field>
  <mat-form-field appearance="outline" *ngIf="!isSafari">
    <mat-label style="font-size: 17px;">Expiration Date <span *ngIf="isExpDateMand">*</span></mat-label>

     
    <input matInput type="date" placeholder="End Date" formControlName="expiryDate" [errorStateMatcher]="matcher" (change)="selectExpDate($event)">
    <mat-error *ngIf="!newDocumentForm.controls['dateGroup'].get('expiryDate').dirty && newDocumentForm.controls['dateGroup'].get('expiryDate').touched && !newDocumentForm.controls['dateGroup'].get('expiryDate').valid" >
      {{errors.expirydate}}
    </mat-error>
    <mat-error >
      {{errors.expirydateValid}}
    </mat-error>
    </mat-form-field>

<!-- Note: margin-top changes based on presence of error -->
<div
    [ngStyle]="{
      'margin-top': (newDocumentForm.get('dateGroup.expiryDate')?.touched && newDocumentForm.get('dateGroup.expiryDate')?.invalid) || newDocumentForm.get('dateGroup')?.hasError('notValid') ? '0px' : '-10px'
    }"
  >
  
<span *ngIf="duration !== null && duration !='' && !documentName.includes('Influenza')" style="color: white;
font-size: 14px;padding-left: 8px;">
Note: It's usually valid <span>{{duration === 'Annual' ? '1 year' : duration}}</span> from the Start-Date/Issue-Date</span>
<span *ngIf="duration !== null && duration !='' && this.documentName.includes('Influenza')" style="color: white;font-size: 14px;padding-left: 8px;">
  Note: Need to take it every year and valid till September 1st</span>  <!--QA-->

 <!-- <span *ngIf="duration !== null && duration !='' && docId !=20" style="color: white;
font-size: 14px;padding-left: 8px;">
Note: It's usually valid <span>{{duration === 'Annual' ? '1 year' : duration}}</span> from the Start-Date/Issue-Date</span>
<span *ngIf="duration !== null && duration !='' && docId == 20" style="color: white;font-size: 14px;padding-left: 8px;">
  Note: Need to take it every year and valid till September 1st</span>--> <!--Prod-->
</div>
</div>
<div >
  <mat-form-field appearance="outline" *ngIf="isLicense"> 
    <mat-label style="font-size: 17px;"> State Name<span>*</span></mat-label>
    <mat-select matInput  placeholder="Choose stateName" formControlName="stateName" autocomplete="off" >
       <!-- Search box inside dropdown -->
  <mat-option>
    <input
      matInput
      placeholder="Search State Name"
      [formControl]="stateNameFilterCtrl"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
    />
  </mat-option>
    <mat-option>Choose  StateName</mat-option>
    <mat-option *ngFor="let state of filteredStateNames " [value] ="state.id">{{state.name}}</mat-option>
    </mat-select>
    <mat-error *ngIf="newDocumentForm.controls['dateGroup'].get('stateName').touched && !newDocumentForm.controls['dateGroup'].get('stateName').valid">
     State Name is required.
    </mat-error>
  </mat-form-field>
</div>
</div>
<div *ngIf="!isEdit && !isAdminAcc" class="row" style="color: #ffffff;margin-left:0px;margin-right:0px;font-size: 15px;">
  <span style=" padding-right:0.6em;">Do you want to recieve notification? </span> 
  <input type="checkbox" style="font-family: 'Century Gothic' !important;" (change)="notifyButton($event, 'YES')" id="Yes" value="YES" [checked]="notification === 'YES'"><label>Yes</label>
  <input type="checkbox" style="font-family: 'Century Gothic' !important;" (change)="notifyButton($event, 'NO')" id="No" value="NO" [checked]="notification === 'NO'"><label>No</label>
</div>
<div mat-dialog-actions style="float:right">
<button *ngIf="!isUpdate && showBtn" class="btn btn-primary" mat-button type="submit" style="color:white"  [disabled]="!newDocumentForm.valid" mat-dialog-close>Add Document</button>
<button  *ngIf="isUpdate && updateBtn" class="btn btn-primary" mat-button type="submit" style="color:white"  [disabled]="!newDocumentForm.valid" mat-dialog-close>Update</button>
<button *ngIf="!isCancelBtn" class="btn btn-danger" (click)="removeFile()" mat-button mat-dialog-close>Close</button>
<button *ngIf="isCancelBtn" class="btn btn-danger" (click)="getPreviousData()" mat-button>Cancel</button>
</div>
</div>
</form>
</div>
<ng-template #isDocExpired>
  <div>
    <h4 class="modal-title w-100"><i class="fa fa-exclamation-circle" style="margin-right:10px;cursor: auto;"></i>You are uploading Expired Document</h4>	
    <h4>Are you sure you want to upload expired document?</h4>
    </div>
    <div style="text-align:center">
      <button style="outline:none;" type="button" class="btn btn-primary" mat-button (click)="submitExpiredDocument(newDocumentForm.value)" mat-dialog-close>YES</button>
      <button style="margin-left:5px;outline:none;" type="button" class="btn btn-primary" mat-button mat-dialog-close (click)="closeAll()">NO</button>
      </div>
</ng-template>
<ng-template #isupdateDocExpired>
  <div>
    <h4 class="modal-title w-100"><i class="fa fa-exclamation-circle" style="margin-right:10px;cursor: auto;"></i>You are uploading expired document</h4>	
    <h4>Are you sure you want to upload expired document?</h4>
    </div>
    <div style="text-align:center">
      <button style="outline:none;" type="button" class="btn btn-primary" mat-button (click)="updateExpiredDocument(newDocumentForm.value)" [mat-dialog-close]="true">YES</button>
      <button style="margin-left:5px;outline:none;" type="button" class="btn btn-secondary" mat-button [mat-dialog-close]="true" (click)="closeAll()">NO</button>
      </div>
</ng-template>
<ng-template #isPreview>
  <div style="display: flex; flex-direction: column;align-items: flex-end;">
    <span (click)="closePre()">&times;</span>
  <!-- IMAGE Preview -->
  <img *ngIf="isImage" [src]="previewUrl" alt="Image Preview" width="400" />

  <!-- PDF Preview -->
  <iframe *ngIf="isPdf" [src]="previewUrl" width="500px" height="500px"></iframe>
  <button style="margin:5px;outline:none;width:fit-content;" type="button" class="btn btn-primary" mat-button  (click)="closePre()">Close</button>
</div>
</ng-template>

    <!--<ng-template #fileViewer>
      <div class="viewFile">
    <div class="closePop">
      <span (click)="closePre()">&times;</span>
      </div>
      <div>
  <tld-file-viewer [src]="previewdata.src" [type]="previewdata.type"></tld-file-viewer>
  </div>
  <div class="closePop">
  <button class="btn btn-danger" (click)="closePre()">Close</button>
  </div>
  </div>
</ng-template>-->
